import axios from "axios";
// import { getApiUrl } from '@/utils/platform-check'

const state = () => ({
  quotes: [],
  loading: false,
  audioFlag: false,
  video: {},
});

const getters = {};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setAudioFlag(state, audioFlag) {
    state.audioFlag = audioFlag;
  },
  updateVideo(state, video) {
    state.video = video;
  },
};

const actions = {
  setLoading({ commit }, loading) {
    commit("setLoading", loading);
  },
  async fetchVideoBySlug({ commit, rootState }, { slug, conferenceType }) {
    commit("setLoading", true);
    try {
      const accessToken = rootState.user.token;
      // TODO to remove after we merge the collection
      let response = null;
        response = await axios.get(
          process.env.VUE_APP_API_URL + `/cms/videos/${slug}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
      commit("updateVideo", response.data);
      commit("setLoading", false);
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },
  setResources(state, resources) {
    if (!Array.isArray(resources)) state.resources = [resources];
    else state.resources = resources;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
